import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = import.meta.env.VITE_API_URL || "";

export default function CashbackToggle({ purchaseAmount, onApply, appliedAmount = 0 }) {
  const [balance,  setBalance]  = useState(null);
  const [enabled,  setEnabled]  = useState(false);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("user_token");
    if (!token) { setLoading(false); return; }

    axios.get(`${API_BASE}/api/mtrade/cashback/balance`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => {
        if (r.data.status) {
          setBalance(r.data.balance || 0);
          setEnabled(r.data.enabled !== false);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const MAX_SPEND  = 500;
  const spendable  = Math.floor(Math.min(balance || 0, purchaseAmount, MAX_SPEND));
  const isApplied  = appliedAmount > 0;

  if (loading || !enabled || !balance || balance < 1 || spendable < 1) return null;

  const handleToggle = () => {
    onApply(isApplied ? 0 : spendable);
  };

  return (
    <div
      className="flex items-center justify-between px-4 py-3 rounded-2xl border-2 transition-all"
      style={{
        borderStyle: isApplied ? "solid" : "dashed",
        borderColor: isApplied ? "var(--color-brand)" : "var(--color-border-strong)",
        background:  isApplied ? "var(--color-brand-light)" : "var(--color-surface)",
      }}
    >
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: isApplied ? "var(--color-brand-border)" : "var(--color-surface-hover)" }}>
          <i className="ri-hand-coin-line text-base" style={{ color: isApplied ? "var(--color-brand)" : "var(--color-text-muted)" }} />
        </div>
        <div>
          <p className="text-sm font-semibold" style={{ color: isApplied ? "var(--color-brand-text)" : "var(--color-text-primary)" }}>
            Cashback Balance
          </p>
          <p className="text-xs" style={{ color: isApplied ? "var(--color-brand)" : "var(--color-text-muted)" }}>
            {isApplied
              ? `−₦${appliedAmount.toLocaleString()} applied`
              : `₦${Math.floor(balance).toLocaleString()} available`}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        {!isApplied && (
          <span className="text-xs text-muted">use ₦{spendable.toLocaleString()}</span>
        )}
        <button
          onClick={handleToggle}
          className="w-11 h-6 rounded-full transition-all relative"
          style={{ background: isApplied ? "var(--color-brand)" : "var(--color-border-strong)" }}
        >
          <div className="w-4 h-4 rounded-full bg-white absolute top-1 transition-all shadow-sm"
            style={{ left: isApplied ? "1.5rem" : "0.25rem" }} />
        </button>
      </div>
    </div>
  );
}